import defaultPageStyles from "src/assets/jss/material-kit-react/defaultPageStyles"

const listingsViewStyles = theme => ({
  body: {
    ...defaultPageStyles,
    "& .page-content-wrapper .main-content-wrapper": {
      "& .cardBody": {
        "& .MuiGrid-container": {
          alignContent: "normal",
          flexWrap: "unset",
        },
      },
    },
  },
})

export default listingsViewStyles
